module.exports = __webpack_public_path__ + "static/media/SV6.dda74e3b.jpg";